import React from 'react';
import styles from './ErrorPage.module.scss';
import { useTranslation } from "react-i18next";
import { ReactComponent as ErrorPageIcon } from "@/assets/icons/ErrorPageLogo.svg";
import { useNavigate } from 'react-router-dom';
import { ROUTES } from '@/route/routes.constants';

export const ErrorPage: React.FC = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();

    return (
        <div className={styles.pageContainer}>
            <div className={styles.logoContainer}><ErrorPageIcon /></div>
            <h2 className={styles.text}>{t('error')}</h2>
            <p className={styles.subText}>
                {t('error_page_msg')}
                <br />
                {t('error_page_sub_msg')}
            </p>
            <p className={styles.subText}>{t('error_page_data_recovery')}</p>
            <div className={styles.buttonGroup}>
                <button className={styles.button} onClick={() => navigate(ROUTES.INSPECTIONS)}>
                    {t('back_to_home')}
                </button>
                <button className={styles.buttonSecondary} onClick={() => window.location.reload()}>
                    {t('reload_page')}
                </button>
            </div>
        </div>
    );
};
